import type { Node } from "@tiptap/pm/model";
import type { EditorState } from "@tiptap/pm/state";

export function findReportSection(doc: Node, type: string): { node: Node; pos: number } | null {
  let section: { node: Node; pos: number } | null = null;
  doc.forEach((node, pos) => {
    if (node.type.name === type) section = { node, pos };
  });
  return section;
}

export function markImpressionStale(before: EditorState, after: EditorState) {
  const previous = findReportSection(before.doc, "findingsSection");
  const current = findReportSection(after.doc, "findingsSection");
  const impression = findReportSection(after.doc, "impressionSection");
  // Initial document loading does not establish when a legacy Impression was generated.
  if (!previous || (current && previous.node.eq(current.node))) return null;
  if (!impression?.node.childCount || impression.node.attrs.findingsChanged === true) return null;
  return after.tr.setNodeAttribute(impression.pos, "findingsChanged", true);
}
